import { gql } from '@apollo/client';

export const RdExpenseFragment = gql`
  fragment RdExpense on RdExpense {
    id
    rdCategory
    rdCategoryConfidence
  }
`;
